import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import emergencieService from "../../../services/emergencieService";
import DetailPageLayout from "../../../components/detail/DetailPageLayout";
import { instanceToken } from "../../../utils/constant";
import { dateInfoItems } from "../../../utils/detailUtils";

const Emergencie = ({ homeAlert }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [emergencies, setEmergencies] = useState(null);

  useEffect(() => {
    const fetchEmergencies = async () => {
      try {
        const res = await emergencieService.getOneEmergencies(
          instanceToken.token,
          id
        );
        setEmergencies(res.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchEmergencies();
  }, [id]);

  const handleRemove = async () => {
    try {
      await emergencieService.deleteEmergencies(instanceToken.token, id);
      homeAlert("Emergencies post have been removed.", false);
      navigate("/emergencies");
    } catch (error) {
      console.log(error);
      homeAlert("Error on server!", true);
    }
  };

  return (
    <DetailPageLayout
      title="Emergency Details"
      subtitle="View and manage emergency contact content"
      breadcrumbs={[
        { label: "Emergencies", path: "/emergencies" },
        { label: `Emergency (ID - ${id})` },
      ]}
      listPath="/emergencies"
      imageUrl={emergencies?.image_url}
      loading={!emergencies}
      editPath={
        emergencies ? `/updateEmergencies/${emergencies.id}` : undefined
      }
      onRemove={handleRemove}
      contentSections={
        emergencies
          ? [
              {
                title: "Address (English)",
                value: emergencies.address_en,
                icon: "notes",
              },
              {
                title: "Address (Myanmar)",
                value: emergencies.address_mm,
                myanmar: true,
                icon: "notes",
              },
              {
                title: "Phone Note",
                value: emergencies.phone_note,
                icon: "info",
              },
            ]
          : []
      }
      infoItems={
        emergencies
          ? [
              { label: "ID", value: String(emergencies.id), icon: "id" },
              {
                label: "Category",
                value: emergencies.category,
                icon: "category",
                badge: "category",
              },
              {
                label: "Name (English)",
                value: emergencies.name_en,
                icon: "title",
              },
              {
                label: "Name (Myanmar)",
                value: emergencies.name_mm,
                icon: "title",
                myanmar: true,
              },
              { label: "Phone", value: emergencies.phone, icon: "phone" },
              { label: "Link", value: emergencies.link, icon: "link" },
              ...dateInfoItems(emergencies),
            ]
          : []
      }
      quickActions={
        emergencies?.link
          ? [
              {
                label: "Open Link",
                onClick: () =>
                  window.open(emergencies.link, "_blank", "noreferrer"),
              },
            ]
          : []
      }
    />
  );
};

export default Emergencie;
